import { HOST_NAME } from '../constants';

/**
 * Returns the url to get the package.json file
 * @param {String} id
 * @return {String} url
 */
export function getVersionUrl(id) {
  return `${HOST_NAME}/${id}/versions.json`;
}

/**
 * Returns the url to the package script
 * @param {String} id
 * @param {Object} versionConfig
 * @param {Boolean} [isExp=false] - is this and Experimental Feature?
 * @return {String} url
 */
export function getModuleUrl(id, versionConfig, isExp = false) {
  const { main, version } = versionConfig;
  const _id = isExp ? `exp/${id}` : id;
  return `${HOST_NAME}/global/${_id}/${version}/${main}`;
}
